import { supabase } from "@/lib/supabase";

export type StudentAccessType = "classroom" | "independent";

export async function loadStudentAccessType(): Promise<StudentAccessType> {
  const { data: { user }, error: userError } = await supabase.auth.getUser();
  if (userError) throw userError;
  if (!user) throw new Error("É necessário entrar na conta.");

  const { data, error } = await supabase
    .from("profiles")
    .select("student_access_type")
    .eq("id", user.id)
    .maybeSingle();

  if (error) throw new Error("Não foi possível carregar o perfil de aluno.");
  return data?.student_access_type === "independent" ? "independent" : "classroom";
}

export async function saveStudentDisplayName(name: string): Promise<void> {
  const { data: { user }, error: userError } = await supabase.auth.getUser();
  if (userError) throw userError;
  if (!user) throw new Error("É necessário entrar na conta.");

  const trimmedName = name.trim();
  if (!trimmedName) throw new Error("Informe seu nome para identificação.");

  const { error } = await supabase
    .from("profiles")
    .update({ name: trimmedName, updated_at: new Date().toISOString() })
    .eq("id", user.id);

  if (error) throw new Error(error.message || "Não foi possível salvar seu nome de identificação.");
}

export async function saveStudentAccessType(accessType: StudentAccessType): Promise<void> {
  const { data: { user }, error: userError } = await supabase.auth.getUser();
  if (userError) throw userError;
  if (!user) throw new Error("É necessário entrar na conta.");

  const { error } = await supabase
    .from("profiles")
    .update({ student_access_type: accessType, updated_at: new Date().toISOString() })
    .eq("id", user.id);

  if (error) throw new Error(error.message || "Não foi possível atualizar o perfil de aluno.");
}
